import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import Home from './pages/Home';
import CampaignDetail from './pages/CampaignDetail';
import AdminLogin from './pages/Admin/AdminLogin';
import AdminDashboard from './pages/Admin/AdminDashboard';
import CampaignForm from './pages/Admin/CampaignForm';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './contexts/LanguageContext';
import { AdminProvider } from './contexts/AdminContext';
import CookieConsent from './components/CookieConsent';
import { trackPageView } from './utils/analytics';

// Component to track page views on route changes
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    const consent = localStorage.getItem('cookie-consent');
    if (consent === 'accepted') {
      trackPageView(location.pathname + location.search);
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AdminProvider>
          <BrowserRouter>
            <PageTracker />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/campaign/:id" element={<CampaignDetail />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/campaign/:id" element={<CampaignForm />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
          <CookieConsent />
        </AdminProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;